module.exports = __webpack_public_path__ + "img/bottom-list2.d4830aec.png";